import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import style from './index.module.scss';

type TProps = {
  breadCrumbs: { name: string; link: string }[];
};

const Breadcrumbs: FC<TProps> = ({ breadCrumbs }) => {
  return (
    <>
      {breadCrumbs.map((elem, index) =>
        index >= breadCrumbs.length - 1 ? (
          <Link to={elem.link} className={style.link} key={elem.link}>
            {elem.name}
          </Link>
        ) : (
          <span className={style.wrapper} key={elem.link}>
            <Link to={elem.link} className={style.link}>
              {elem.name}
            </Link>
            <span> / </span>
          </span>
        ),
      )}
    </>
  );
};

export default Breadcrumbs;
